import { render, staticRenderFns } from "./UserOnlineServTab.vue?vue&type=template&id=51eddf94&"
import script from "./UserOnlineServTab.vue?vue&type=script&lang=js&"
export * from "./UserOnlineServTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserOnlineServTab.vue"
export default component.exports